export const generateUniqueId = () => {
  const timestamp = Date.now().toString(36); // Convert to base36 for shorter string
  const randomPart1 = Math.random().toString(36).substring(2, 15);
  const randomPart2 = Math.random().toString(36).substring(2, 15);
  const randomPart3 = performance.now().toString(36).replace('.', '');

  return `${timestamp}-${randomPart1}-${randomPart2}-${randomPart3}`;
};
